<button
  [disabled]="disabled"
  class="button button--{{ buttonType }}"
  [ngClass]="{
    'button--full-width': fullWidth,
    'button--disabled': disabled,
    'button--small': isBtnSmall
  }"
>
  {{ text }}
</button>
